import React from 'react';
import { makeStyles } from '@material-ui/core';

import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';

export type Props = TooltipProps;

const useStyles = makeStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[1],
    fontSize: theme.typography.fontSize,
  },
  popper: {
    opacity: 1,
  },
}));

const TooltipNext: React.FC<TooltipProps> = ({ children, ...rest }) => {
  const classes = useStyles();

  return (
    <Tooltip
      classes={{ tooltip: classes.tooltip, popper: classes.popper }}
      enterTouchDelay={100}
      {...rest}
    >
      {children || <InfoIcon />}
    </Tooltip>
  );
};

export default TooltipNext;
